import { GlobalState } from '../../../store/global';
import { createSelector } from '@ngrx/store';
import { RightPanelTabs } from '../locations-skeleton.component';

export const state = (state: GlobalState) => state.locations.skeleton;

export const selectContainerDimensionsInitialized = createSelector(
    state, (state) => state.containerDimensionsInitialized);

export const selectContainerResizing = createSelector(
    state, (state) => state.resizing);

// right panel

export const selectRightPanelRelativeWidth = createSelector(
    state, (state) => state.rightPanelRelativeWidth);

export const selectSelectedRightPanelTab = createSelector(
    state, (state) => state.selectedRightPanelTab);

export const selectRightPanelActive = createSelector(
    state, (state) => state.rightPanelActive);

export const selectUnsavedChangesInRightPanelTab = createSelector(
    state, (state) => state.unsavedChangesInRightPanelTab);

export const selectPermissionToDestroyRightPanelTabContainerRequired = createSelector(
    selectRightPanelActive,
    selectUnsavedChangesInRightPanelTab,
    (rightPanelActive, unsavedChangesInRightPanelTab) => rightPanelActive && unsavedChangesInRightPanelTab);

export const selectIsMapActive = createSelector(
    selectRightPanelActive, selectSelectedRightPanelTab, (
        rightPanelActive, rightPanelTab) => {
      return rightPanelActive && rightPanelTab === RightPanelTabs.MAP;
    });

// bottom panel

export const selectBottomPanelRelativeHeight = createSelector(
    state, (state) => state.bottomPanelRelativeHeight);

export const selectSelectedBottomPanelTab = createSelector(
    state, (state) => state.selectedBottomPanelTab);

export const selectBottomPanelActive = createSelector(
    state, (state) => state.bottomPanelActive);

export const selectUnsavedChangesInBottomPanelTab = createSelector(
    state, (state) => state.unsavedChangesInBottomPanelTab);

export const selectPermissionToDestroyBottomPanelTabContainerRequired = createSelector(
    selectBottomPanelActive,
    selectUnsavedChangesInBottomPanelTab,
    (bottomPanelActive, unsavedChangesInBottomPanelTab) => bottomPanelActive && unsavedChangesInBottomPanelTab);
